const init = () => {
  const pageTitle = `
  <div class="page_title">
    <h2><strong>新着情報</strong><span>NEWS</span></h2>
  </div>
  `

  $(window).on('load', function(){
    $('.breadcrumbs').before(pageTitle);
  });
}

export default function NEWS() {
  $( init )
}